import React, {useState, useEffect, useCallback, useRef} from 'react';
import {useSelector} from "react-redux";
import {userSelector} from "../../store/slices/userSlice";
import { socket } from '../../socket';

import ChatContainer from "../ChatContainer";
import AddConversationContainer from "../AddConversationContainer";
import Conversation from "../../components/Conversation";

import "./chatSupport.css"
import instance from '../../api.config';

function ChatSupport() {
    const {currentUser} = useSelector(userSelector)
    const [currentChat, setCurrentChat] = useState(null);
    const [chats, setChats] = useState([]);
    const [clicked, setClicked] = useState(false);
    const [arrivalMessage, setArrivalMessage] = useState(null);
    const [active, setActive] = useState(false);
    const listRequestVersion = useRef(0);

    const refreshChats = useCallback(() => {
        // Invalidate an in-flight count immediately, before the next effect runs.
        listRequestVersion.current += 1;
        setArrivalMessage({});
    }, []);

    const handleMessagesRead = useCallback(chatId => {
        setChats(previous => previous.map(chat => String(chat.id) === String(chatId)
            ? { ...chat, newMsgCount: 0 } : chat));
        refreshChats();
    }, [refreshChats]);

    const changeChat = (chat) => {
        setClicked(false)
        setCurrentChat(chat)
        setChats(previous => previous.map(item => item.id === chat.id
            ? { ...item, newMsgCount: 0 } : item));

        if(chat){
            localStorage.setItem('currentChatId', chat?.id);
        }
            
    }

    useEffect(() => {
        const handleChatCreated = chat => {
            setChats(previous => [chat, ...previous.filter(item => String(item.id) !== String(chat.id))]);
        };
        socket.on('chatCreated', handleChatCreated);
        socket.on('messageCreated', refreshChats);
        socket.on('supportMessageCreate', refreshChats);
        socket.on('connect', refreshChats);
        return () => {
            socket.off('chatCreated', handleChatCreated);
            socket.off('messageCreated', refreshChats);
            socket.off('supportMessageCreate', refreshChats);
            socket.off('connect', refreshChats);
        };
    }, [refreshChats]);


    useEffect(() => {
        let active = true;
        const requestVersion = ++listRequestVersion.current;
        async function fetchData() {
            try {
                const response = await instance.get('/getChats/' + currentUser.id)
                if (active && requestVersion === listRequestVersion.current) setChats(response.data);
            } catch (e) {
                console.log(e)
            }
        }

        fetchData().then()
        return () => { active = false; };
    }, [currentUser.id, arrivalMessage])

    return (
        <div className='d-flex flex-grow-1'>
            <div className="chats-container">
                <div className="left-box">
                    {chats.map((c) => (
                        <Conversation key={c.id} active={active} onClick={() => {changeChat(c); setActive(c.id)}} conversation={c} currentUser={currentUser}/>
                    ))}
                </div>
                <div className='d-flex flex-grow-1'>
                    {!clicked ? <>
                            <ChatContainer
                                currentChat={currentChat}
                                currentUser={currentUser}
                                onMessagesRead={handleMessagesRead}/> </> :
                        <AddConversationContainer currentUser={currentUser}/>}
                </div>
            </div>
        </div>
    );
}

export default ChatSupport;